(function(){
  if (window.SoukBring) return;
  var WA = 'https://wa.me/96178906296?text=Hello+CoffeeSouks%21';
  var STEPS = [
    {k:null, ask:'How do you brew at home?', opts:[['Espresso','coffee-for-espresso'],['Moka pot','coffee-for-moka-pot'],['V60 & filter','coffee-for-filter'],['French press','coffee-for-french-press'],['Rakweh (Turkish)','coffee-for-turkish'],['Capsules','capsules']]},
    {k:'filter.p.m.custom.taste_profile', ask:'What do you like in your cup?', opts:[['Chocolatey & nutty','Chocolatey'],['Fruity & bright','Fruity'],['Balanced & sweet','Balanced'],['Strong & bold','Bold']]},
    {k:'filter.p.m.custom.grade', ask:'How special should it be?', opts:[['Silver · 81–82','Silver 81–82'],['Premium · 83–85','Premium 83–85'],['Gold · 86–88','Gold 86–88'],['Cup of Excellence · 90+','90+ Cup of Excellence']]}
  ];
  var FACE = `<svg width='28' height='28' viewBox='0 0 34 34' aria-hidden='true'><path d='M17 3.5v5' stroke='#fff' stroke-width='2' stroke-linecap='round'/><circle cx='17' cy='3.5' r='2.3' fill='#F2B53A'/><rect x='5' y='9' width='24' height='18' rx='7' fill='#fff'/><rect class='sd-eye' x='11' y='14.5' width='3.6' height='6.5' rx='1.8' fill='#0F6BDC'/><rect class='sd-eye' x='19.4' y='14.5' width='3.6' height='6.5' rx='1.8' fill='#0F6BDC'/></svg>`;
  var root, body, answers = [], busy = false;

  function build(){
    root = document.createElement('div');
    root.className = 'sdb';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'Bring, coffee assistant');
    root.innerHTML = `<button type='button' class='sdb-scrim' aria-label='Close'></button>
      <div class='sdb-sheet'>
        <div class='sdb-grab'></div>
        <div class='sdb-head'><span class='sdb-av'>${FACE}</span><span><b>Bring</b><small>Coffee assistant · replies instantly</small></span>
          <button type='button' class='sdb-x' aria-label='Close'><svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#5B6472' stroke-width='2.5' stroke-linecap='round' aria-hidden='true'><path d='M6 6l12 12M18 6L6 18'/></svg></button></div>
        <div class='sdb-body' aria-live='polite'></div>
        <form class='sdb-ask' role='search'><label class='sdb-sr' for='sdb-q'>Search products</label><input id='sdb-q' type='search' autocomplete='off' placeholder='Type a product, brand or brew…'><button type='submit' aria-label='Search'><svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' aria-hidden='true'><circle cx='11' cy='11' r='6.5'/><path d='M20 20l-4-4'/></svg></button></form>
        <div class='sdb-foot'>
          <button type='button' class='sdb-ai'><svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linejoin='round' aria-hidden='true'><path d='M4 5h16v11H9l-5 4z'/></svg>Ask Bring anything</button>
          <button type='button' class='sdb-wa'><svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 20l1.3-3.8A8 8 0 1 1 8 19z'/></svg>WhatsApp</button>
        </div>
      </div>`;
    document.body.appendChild(root);
    body = root.querySelector('.sdb-body');
    root.querySelector('.sdb-scrim').addEventListener('click', close);
    root.querySelector('.sdb-x').addEventListener('click', close);
    root.querySelector('.sdb-ai').addEventListener('click', toAI);
    root.querySelector('.sdb-ask').addEventListener('submit', function(e){ e.preventDefault(); var i = root.querySelector('#sdb-q'); var q = i.value.trim(); if (!q || busy) return; i.value = ''; i.blur(); search(q); });
    root.querySelector('.sdb-wa').addEventListener('click', function(){ window.open(WA, '_blank'); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('on')) close(); });
  }

  function scroll(){ body.scrollTop = body.scrollHeight; }
  function bot(text){ var d = document.createElement('div'); d.className = 'sdb-msg sdb-bot'; d.textContent = text; body.appendChild(d); scroll(); return d; }
  function me(text){ var d = document.createElement('div'); d.className = 'sdb-msg sdb-me'; d.textContent = text; body.appendChild(d); scroll(); }
  function typing(){ var d = document.createElement('div'); d.className = 'sdb-msg sdb-bot sdb-dots'; d.innerHTML = '<i></i><i></i><i></i>'; body.appendChild(d); scroll(); return d; }
  function chips(list){
    var w = document.createElement('div'); w.className = 'sdb-chips';
    list.forEach(function(c){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sdb-chip' + (c.cls ? ' ' + c.cls : ''); b.textContent = c.label;
      b.addEventListener('click', function(){ if (busy) return; w.remove(); c.go(); });
      w.appendChild(b);
    });
    body.appendChild(w); scroll();
  }
  function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
  function say(text, ms){ var t = typing(); return wait(ms || 700).then(function(){ t.remove(); bot(text); }); }

  function params(upto){
    var p = [];
    for (var i = 1; i < upto; i++){ if (answers[i]) p.push([STEPS[i].k, answers[i]]); }
    return p;
  }
  function base(){ return answers[0] || 'coffee'; }
  function noun(){ return base() === 'capsules' ? 'capsules' : 'coffees'; }
  function qs(p){ return p.map(function(x){ return encodeURIComponent(x[0]) + '=' + encodeURIComponent(x[1]); }).join('&'); }
  function fetchSet(handle, p){
    var q = qs(p);
    var url = '/collections/' + handle + '?' + (q ? q + '&' : '') + 'section_id=sd-finder-results';
    return fetch(url, {credentials: 'same-origin'}).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.getElementById('sd-fr');
      var data = s ? JSON.parse(s.textContent) : {count: 0, items: []};
      data.link = '/collections/' + handle + (q ? '?' + q : '');
      return data;
    }).catch(function(){ return {count: 0, items: [], link: '/collections/' + handle}; });
  }

  function cards(items){
    var w = document.createElement('div'); w.className = 'sdb-cards';
    items.forEach(function(it){
      var c = document.createElement('div'); c.className = 'sdb-card';
      var a = document.createElement('a'); a.href = it.u;
      var img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; if (it.i) img.src = it.i; a.appendChild(img);
      var inn = document.createElement('div'); inn.className = 'in';
      [['v', it.v], ['t', it.t], ['n', it.n], ['p', (it.f ? 'From ' : '') + it.p]].forEach(function(x){
        if (!x[1]) return; var s = document.createElement('span'); s.className = x[0]; s.textContent = x[1]; inn.appendChild(s);
      });
      a.appendChild(inn); c.appendChild(a);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sdb-add'; b.textContent = it.id ? 'Add to cart' : 'View product';
      b.addEventListener('click', function(){ if (it.id) add(it, b); else location.href = it.u; });
      c.appendChild(b);
      w.appendChild(c);
    });
    body.appendChild(w); scroll();
  }
  function link(text, href){ var a = document.createElement('a'); a.className = 'sdb-link'; a.href = href; a.textContent = text + ' →'; body.appendChild(a); scroll(); }

  function add(it, b){
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id: it.id, quantity: 1}]})})
      .then(function(r){ if (!r.ok) throw new Error('add'); return fetch('/cart.js', {credentials: 'same-origin'}); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        b.disabled = false; b.classList.add('ok'); b.textContent = 'Added ✓';
        try { document.dispatchEvent(new CustomEvent('cart:update', {bubbles: true, detail: {resource: cart, sourceId: 'sd-bring', data: {source: 'sd-bring', itemCount: cart.item_count}}})); } catch(e){}
        document.querySelectorAll('.cart-bubble__text-count').forEach(function(n){ n.textContent = cart.item_count; });
      })
      .catch(function(){ b.disabled = false; b.textContent = 'Choose options'; b.onclick = function(){ location.href = it.u; }; });
  }

  function menu(){
    chips([
      {label: 'Find my coffee in 3 taps', go: startFinder},
      {label: 'Espresso machines', cls: 'alt', go: function(){ showSet('Espresso machines', 'home-machines'); }},
      {label: 'Grinders', cls: 'alt', go: function(){ showSet('Grinders', 'grinders'); }},
      {label: 'Black November offer', cls: 'alt', go: function(){ showSet('Black November offer', 'custom-roast-group', 'Buy 1 bag, get 1 free on all Custom Roast Group coffee until 30 November. These are the top picks:'); }},
      {label: 'Delivery & payment', cls: 'alt', go: delivery}
    ]);
  }
  function greet(){
    say('Hi! I’m Bring, your coffee assistant. I can find your perfect coffee in 3 taps, or help you pick a machine, a grinder or a gift.', 900).then(menu);
  }
  function delivery(){
    me('Delivery & payment');
    say('In Beirut, orders from one Beirut brand placed before 5 PM arrive the same day, Monday to Friday. Orders from two or more brands take 2–3 working days. Outside Beirut, delivery takes 1–4 working days. We don’t deliver on Saturday and Sunday. You can pay cash on delivery or with Whish, and every product is 100% genuine.').then(function(){ wait(300).then(menu); });
  }
  function showSet(label, handle, intro){
    me(label); busy = true;
    var t = typing();
    fetchSet(handle, []).then(function(d){
      t.remove(); busy = false;
      if (!d.items.length){ bot('I could not load these right now. Ask me anything below and I will help.'); return menu(); }
      bot(intro || 'Here are popular picks our customers love:');
      cards(d.items);
      link('See all ' + d.count, d.link);
      wait(400).then(function(){ chips([{label: 'Find my coffee', go: startFinder}, {label: 'Something else', cls: 'alt', go: function(){ me('Something else'); say('Sure, what would you like to look at?').then(menu); }}]); });
    });
  }

  function startFinder(){
    answers = [];
    me('Find my coffee');
    ask(0, null);
  }
  function ask(i, count){
    var pre = count == null ? '' : (count + ' ' + noun() + ' fit so far. ');
    say(pre + STEPS[i].ask, 650).then(function(){
      var list = STEPS[i].opts.map(function(o){ return {label: o[0], go: function(){ pick(i, o[0], o[1]); }}; });
      list.push({label: 'Not sure', cls: 'alt', go: function(){ pick(i, 'Not sure', ''); }});
      chips(list);
    });
  }
  function pick(i, label, val){
    me(label); answers[i] = val; busy = true;
    var t = typing();
    fetchSet(base(), params(i + 1)).then(function(d){
      t.remove(); busy = false;
      if (d.count === 0 && val){
        answers[i] = '';
        bot('Nothing matches that exact mix yet, so I will keep that one open.');
        return fetchSet(base(), params(i + 1)).then(function(d2){ next(i, d2); });
      }
      next(i, d);
    });
  }
  function next(i, d){
    var last = base() === 'capsules' ? 1 : STEPS.length - 1;
    if (i < last) return ask(i + 1, d.count);
    results(d);
  }
  function results(d){
    if (!d.items.length){ bot('I could not find a match right now. Let me show you our best sellers instead.'); return showSet('Best sellers', 'best-selling-coffee'); }
    bot(d.count === 1 ? 'I found 1 match for you:' : 'I found ' + d.count + ' ' + noun() + ' for you. Here are my top picks:');
    cards(d.items);
    if (d.count > d.items.length) link('See all ' + d.count + ' matches', d.link);
    wait(400).then(function(){
      chips([
        {label: 'Start again', go: startFinder},
        {label: 'I need a grinder too', cls: 'alt', go: function(){ showSet('Grinders', 'grinders'); }},
        {label: 'Talk to a barista', cls: 'wa', go: function(){ window.open(WA, '_blank'); }}
      ]);
    });
  }

  function money(v){ var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2); }
  function search(q){
    me(q); busy = true;
    var t = typing();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(j){
      t.remove(); busy = false;
      var res = (j && j.resources && j.resources.results) || {};
      var cols = (res.collections || []).slice(0, 3);
      var items = (res.products || []).filter(function(p){ return p.available !== false; }).slice(0, 6).map(function(p){
        var v = (p.variants && p.variants[0]) || {};
        return {t: p.title, v: p.vendor, u: p.url, i: (p.featured_image && p.featured_image.url) || p.image || '', p: money(p.price), f: p.price_max && p.price_min && p.price_max !== p.price_min, id: v.id || null, n: ''};
      });
      if (!items.length && !cols.length){
        bot('I could not find ' + q + '. Bring or a barista can help you with it.');
        return chips([{label: 'Ask Bring', go: toAI}, {label: 'Talk to a barista', cls: 'wa', go: function(){ window.open(WA, '_blank'); }}, {label: 'Find my coffee', cls: 'alt', go: startFinder}]);
      }
      if (items.length){ bot('Here is what I found for ' + q + ':'); cards(items); }
      cols.forEach(function(c){ link(c.title, c.url); });
      link('See all results for ' + q, '/search?q=' + encodeURIComponent(q));
    }).catch(function(){ t.remove(); busy = false; location.href = '/search?q=' + encodeURIComponent(q); });
  }

  function toAI(){
    close();
    var b = document.querySelector('.cg-launch');
    if (b) setTimeout(function(){ b.click(); }, 260); else window.open(WA, '_blank');
  }
  function open(mode){
    if (!root) build();
    root.classList.add('on');
    document.documentElement.classList.add('sdb-lock');
    if (!body.children.length){
      if (mode === 'finder'){ say('Hi! I’m Bring. Let’s find your perfect coffee in 3 taps.', 700).then(function(){ answers = []; ask(0, null); }); }
      else greet();
    } else if (mode === 'finder' && !busy){ startFinder(); }
  }
  function close(){
    if (!root) return;
    root.classList.remove('on');
    document.documentElement.classList.remove('sdb-lock');
  }
  window.SoukBring = {open: open, close: close, ai: toAI};
})();
